"use strict";

var screenersImport = require("../../screeners");

var utils = require("../../screeners/utils");

var causalAnalysisQuestionScale = ["Overloaded with work", "Current project not engaging/interesting", "Lacking resources to do job", "Lacking support to do job", "Uncertainty if my job is secure", "Not paid enough for the work I do", "Frustrated with a colleague/colleagues", "Family issue", "Unfair/disrespectful treatment by management", "Bullying", "Not sure what's expected of me for task/role/project", "Not recognised enough for the work I do", "Lacking friendships/peer support at work", "Lacking opportunities to work on what I like", "N/A"];
var likertLikeScale = ["At no time", "Some of the time", "Less than half the time", "More than half the time", "Most of the time", "All of the time"]; // const questionArray = [
// 	{
// 		'question' : 'I have felt cheerful and in good spirits',
// 		'scale' : likertLikeScale
// 	},
// 	{
// 		'question' : 'I have felt calm and relaxed',
// 		'scale' : likertLikeScale
// 	},
// 	{
// 		'question' : 'I have felt active and vigorous',
// 		'scale' : likertLikeScale
// 	},
// 	{
// 		'question' : 'I woke up feeling fresh and rested',
// 		'scale' : likertLikeScale
// 	},
// 	{
// 		'question' : 'My daily life has been filled with things that interest me',
// 		'scale' : likertLikeScale
// 	},
// 	{
// 		'question' : 'The following have made it hard for me to work effectively',
// 		'scale' : causalAnalysisQuestionScale
// 	}
// ]

var questions = screenersImport.expandscreeners([utils.screeners.WHO5, {
  batteryId: "WHO5",
  question: "Have any of the following <b>made it hard for you to work<br /> effectively</b> (you can choose multiple options)",
  options: causalAnalysisQuestionScale
}]);

var analysis = function analysis(answers, bonus) {
  var who5answers;

  if (answers.WHO5) {
    who5answers = answers.WHO5;
  } else {
    who5answers = answers;
  } // Add the bonus question to answer array so can extract the results


  bonus && bonus.causal ? null : bonus ? who5answers.push(bonus) : null;
  if (!who5answers) return null;
  var results = {};
  [utils.screeners.WHO5].forEach(function (battery) {
    results = Object.assign(results, screenersImport.extractResults(questions, who5answers, battery));
    results;
  });
  questions.forEach(function (q, i) {
    if (!q.key) return;
    results[q.key] = q.eval(who5answers[i]);
  });
  return results;
};

module.exports = {
  questions: questions,
  analysis: analysis,
  causalAnalysisQuestionScale: causalAnalysisQuestionScale
};